import React, { Fragment } from 'react'
import {camelCase} from '../../../../../utils';

const Dates = ({item, index,text}) => (
  <Fragment className="dates">
    <dt>{`${text} ${index+1}`}</dt>
    <dd>{item}</dd>
  </Fragment>
)

const StandardSweepInstruction = ({item,pageJson,translations,translateWordForOption}) => {
  if(item !== undefined) {
    let  sweepTimeType = item.sweepTime !== undefined && 'customSweepTime' in item.sweepTime && item.sweepTime.customSweepTime !== null ? item.sweepTime.sweepTimeType.replace(/([A-Z])/g, ' $1').trim() : ''
    return (
      <div className="cc-detail-container gdocs-mleft-25">
        <div className="cc-detail-container__heading">{translations(pageJson.pageHeading)}</div>
        <div className="cc-detail-container__content">
          <dl className="cc-detail-container__horizontal-row">
            {
              item.sweepTime !== undefined && 'customSweepTime' in item.sweepTime && item.sweepTime.customSweepTime !== null
              ? [
                  <dt>{translations(pageJson.textSweepTime)}</dt>,
                  <dd>
                    <span>{camelCase(item.sweepTime.sweepTimeType.replace(/([A-Z])/g, ' $1').trim())}</span><br/>
                    <span>{item.sweepTime.customSweepTime}</span>
                  </dd>
                ]
              : [
                  <dt>{translations(pageJson.textSweepTime)}</dt>,
                   <dd>{camelCase(item.sweepTime.sweepTimeType.replace(/([A-Z])/g, ' $1').trim())}</dd>
                ]
            }

            <dt>{translations(pageJson.textSweepFrequency)}</dt>
            {
              item.sweepFrequency !== undefined && item.sweepFrequency.frequencyType !== undefined
              ? <dd>{item.sweepFrequency.frequencyType.name}</dd>
              : <dd>&nbsp;</dd>
            }
            {
              item.sweepFrequency !== undefined && item.sweepFrequency.frequencyType !== undefined && item.sweepFrequency.frequencyType.name == 'Weekly'
              ? [
                  <dt>{translations(pageJson.textSettlementDate)}</dt>,
                  <dd>{item.sweepFrequency.frequencyDetails.name}</dd>
                ]
              : null
            }
            {
              item.sweepFrequency !== undefined && item.sweepFrequency.frequencyType !== undefined && item.sweepFrequency.frequencyType.name === 'Quarterly'
              ? [
                  <dt>{translations(pageJson.textSettlementDate)}</dt>,
                  <dd>{item.sweepFrequency.frequencyDetails.name}</dd>
                ]
              : null
            }
            {
              item.sweepFrequency !== undefined && item.sweepFrequency.frequencyType !== undefined && item.sweepFrequency.frequencyType.name === 'Monthly'
              ? item.sweepFrequency !== undefined && item.sweepFrequency.frequencyType !== undefined && item.sweepFrequency.frequencyType.name === 'Monthly' && item.sweepFrequency.frequencyDetails !== undefined && item.sweepFrequency.frequencyDetails.name !== undefined && item.sweepFrequency.frequencyDetails.name === 'Specific day'
                ? [
                    <dt>{translations(pageJson.textSettlementDate)}</dt>,
                    <dd>{item.sweepFrequency.frequencyDetails.name}</dd>,
                    <dt>{'Choose Day'}</dt>,
                    <dd>{item.sweepFrequency.frequencyDetailValue.name}</dd>
                  ]
                  : [
                      <dt>{translations(pageJson.textSettlementDate)}</dt>,
                      <dd>{item.sweepFrequency.frequencyDetails.name}</dd>
                    ]
              : null
            }
            {
              item.sweepFrequency !== undefined && item.sweepFrequency.frequencyType !== undefined && item.sweepFrequency.frequencyType.name === 'Calender Date'
              ? item.sweepFrequency.dates.filter(item => item !== '').map((item,i) => <Dates item={item} index={i} text={translations(pageJson.textSettlementDate)}/>)
              : null
            }
            {
              item.sweepFrequency !== undefined && item.sweepFrequency.frequencyType !== undefined && item.sweepFrequency.frequencyType.name === 'Annually'
              ? [
                  <dt>{translations(pageJson.textSettlementDate)}</dt>,
                  <dd>{item.sweepFrequency.annualDate}</dd>
                ]
              : null
            }
            <dt>{translations(pageJson.textForcedPartialReject)}</dt>
            {
              item.forcePartialReject !== undefined
              ? <dd>{item.forcePartialReject.name}</dd>
              : <dd>&nbsp;</dd>
            }
            <dt>{translations(pageJson.textBalanceType)}</dt>
            {
              item.balanceType !== undefined
              ? <dd>{item.balanceType.name}</dd>
              : <dd>&nbsp;</dd>
            }
            <dt>{translations(pageJson.textMaximumRequestFunds)}</dt>
            <dd>{item.specificFundRequest === 'unlimited' ? camelCase(item.specificFundRequest) : `Specific ${'fundAmount' in item && item.fundAmount !== undefined ? item.fundAmount : ''}`}</dd>
            <dt>{translations(pageJson.textBackValuedSweepOption)}</dt>
            {
              item.backValuedSweepOption !== undefined
              ? <dd>{item.backValuedSweepOption.name}</dd>
              : <dd>&nbsp;</dd>
            }
            <dt>{translations(pageJson.textReverseSweepOption)}</dt>
            {
              item.reverseSweepOption !== undefined
              ? <dd>{item.reverseSweepOption.name}</dd>
              : <dd>&nbsp;</dd>
            }
            <dt>{translations(pageJson.textMasterHolidaySweepOption)}</dt>
            {
              item.masterHolidaySweepOption !== undefined
              ? <dd>{item.masterHolidaySweepOption.name}</dd>
              : <dd>&nbsp;</dd>
            }
          </dl>
        </div>
      </div>
    )
  }else {
    return null;
  }
}

export default StandardSweepInstruction;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/CCPreview/SweepInstruction/StandardSweepInstruction.js